var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuIco3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.14 12.94c.04-.3.06-.61.06-.94s-.02-.64-.06-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.91-3.32c-.11-.2-.37-.27-.57-.16l-2.39.96a7.007 7.007 0 0 0-1.63-.95l-.36-2.65A.488.488 0 0 0 14 2h-4c-.24 0-.44.17-.48.41l-.36 2.65c-.6.22-1.17.52-1.63.95l-2.39-.96a.488.488 0 0 0-.57.16l-1.91 3.32a.495.495 0 0 0 .12.61l2.03 1.58c-.04.3-.06.61-.06.94s.02.64.06.94l-2.03 1.58a.495.495 0 0 0-.12.61l1.91 3.32c.11.2.37.27.57.16l2.39-.96c.46.43 1.03.73 1.63.95l.36 2.65c.04.24.24.41.48.41h4c.24 0 .44-.17.48-.41l.36-2.65c.6-.22 1.17-.52 1.63-.95l2.39.96c.2.11.46.04.57-.16l1.91-3.32a.495.495 0 0 0-.12-.61l-2.03-1.58zm-7.14 2.06a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIco3);
export default __webpack_public_path__ + "static/media/menu_ico_3.9b35f104dfe052822f5e536d9bdcf0da.svg";
export { ForwardRef as ReactComponent };